import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".NoOffer-module_wrapper__RWNMG {\n  background-color: var(--pp-color-special-autoshipmentLight);\n  border-radius: 5px;\n}";
var styles = {"wrapper":"NoOffer-module_wrapper__RWNMG"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=NoOffer.module.scss.js.map
